import { useTranslation } from "react-i18next";

import { CommonNavItemProps, NavItem } from "../parts/nav_item";

export const AuditPlannerNavItem = (props: CommonNavItemProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "navBar.items" });
  return (
    <NavItem
      icon="audit-planner"
      isActiveTest={(path) => path.match(/^\/audit_planner/)}
      {...props}
      name={t("aiPlanner")}
      id="audit_planner"
      href="/audit_planner"
    />
  );
};
